import React, { useState, useEffect } from "react";
import { Link as ScrollLink } from "react-scroll";

export default function Navbar({ onOpenSignup }) {
  const [open, setOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(document.documentElement.classList.contains("dark"));
  const [progress, setProgress] = useState(0);

  // theme toggle with persistence
  function toggleTheme(){
    const isDark = document.documentElement.classList.toggle("dark");
    localStorage.setItem("theme", isDark ? "dark" : "light");
    setDarkMode(isDark);
  }

  // scroll progress bar
  useEffect(() => {
    function onScroll() {
      const doc = document.documentElement;
      const total = doc.scrollHeight - doc.clientHeight;
      const pct = total > 0 ? (doc.scrollTop / total) * 100 : 0;
      setProgress(pct);
      const progEl = document.getElementById("scroll-progress");
      if (progEl) progEl.style.width = `${pct}%`;
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="backdrop-filter backdrop-blur-md glass sticky top-0 z-40 border-b border-gray-200 dark:border-gray-800">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-[#06b6d4] to-[#7c3aed] flex items-center justify-center text-white font-bold shadow">FB</div>
          <div>
            <div className="text-lg font-bold">FinBit</div>
            <div className="text-xs text-gray-500 dark:text-gray-400 -mt-1">Stay Financially Healthy — for students</div>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-4">
          <ScrollLink activeClass="underline" to="features" spy={true} smooth={true} offset={-80} duration={400} className="cursor-pointer text-sm hover:underline">Features</ScrollLink>
          <ScrollLink to="how" spy={true} smooth={true} offset={-80} duration={400} className="cursor-pointer text-sm hover:underline">How it works</ScrollLink>
          <ScrollLink to="testimonials" spy={true} smooth={true} offset={-80} duration={400} className="cursor-pointer text-sm hover:underline">Students</ScrollLink>

          <button onClick={toggleTheme} className="px-3 py-2 rounded-md bg-gray-100 dark:bg-gray-800">
            {darkMode ? '🌞' : '🌙'}
          </button>

          <button onClick={onOpenSignup} className="px-4 py-2 rounded-full bg-gradient-to-r from-[#06b6d4] to-[#7c3aed] text-white shadow">Join Beta</button>
        </nav>

        <div className="md:hidden flex items-center gap-2">
          <button onClick={toggleTheme} className="px-2 py-1 rounded-md bg-gray-100 dark:bg-gray-800">{darkMode ? "🌞" : "🌙"}</button>
          <button onClick={() => setOpen(!open)} className="p-2">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" className="text-gray-700 dark:text-gray-200"><path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round"/></svg>
          </button>
        </div>
      </div>

      {/* mobile menu */}
      {open && (
        <div className="md:hidden border-t border-gray-200 dark:border-gray-800">
          <div className="px-6 py-4 flex flex-col gap-3">
            <ScrollLink to="features" spy smooth offset={-80} duration={350} className="py-2 cursor-pointer" onClick={() => setOpen(false)}>Features</ScrollLink>
            <ScrollLink to="how" spy smooth offset={-80} duration={350} className="py-2 cursor-pointer" onClick={() => setOpen(false)}>How it works</ScrollLink>
            <ScrollLink to="testimonials" spy smooth offset={-80} duration={350} className="py-2 cursor-pointer" onClick={() => setOpen(false)}>Students</ScrollLink>
            <button onClick={onOpenSignup} className="mt-2 px-4 py-2 rounded-full bg-gradient-to-r from-[#06b6d4] to-[#7c3aed] text-white">Join Beta</button>
          </div>
        </div>
      )}
    </header>
  );
}
